import React from 'react'
import { useTable } from '../../Components/useTable';



const ProductCategories = () => {
const type="Product Categories"
    const headCells = [
        { id: "name", numeric: false, label: "Name" },
        { id: "description", numeric: false, label: "Description" },
        { id: "createdAt", numeric: false, label: "Created at" },
        { id: "action", numeric: false, label: "Action" },
      ];
   
      const { tableUI } = useTable({
        headCells,
        type
      });
  return (

<div className='admin-body'>
      <div className="table-area">{tableUI}</div>
    </div>
    
  )
}

export default ProductCategories